import React, { Component } from 'react';
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';
import TableFooter from './TableFooter.jsx';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper.js';

const Table = (props) => {
    const { clienteResultadoBusqueda, empresas, novedades } = props.tarjetas;
    const limitesCliente = GlobalHelper.ObtenerLimitesEmpresaCliente(empresas, (novedades || []), clienteResultadoBusqueda);

    return (
        <table className="table table-striped">
            <TableHeader limitesCliente={limitesCliente} />
            <TableBody
                tarjetas={props.tarjetas}
                data={props.data}
                permisos={props.permisos}
                seleccionarEmpresa={props.seleccionarEmpresa}
                openModalInformacionEmpresa={props.openModalInformacionEmpresa}
            />
            <TableFooter cliente={clienteResultadoBusqueda} limitesCliente={limitesCliente} />
        </table>
    );

}

export default Table